import type { HistogramChartLegendProps } from '../types/histogram-props.js';

export const Legend = (props: HistogramChartLegendProps) => null;

Legend['displayName'] = 'HistogramChart.Legend';
